module.exports = __webpack_public_path__ + "img/partner_yishujia.e0a2cc38.png";